import { render, staticRenderFns } from "./ColorsEditorMenu.vue?vue&type=template&id=45a7d233&scoped=true&"
import script from "./ColorsEditorMenu.vue?vue&type=script&lang=js&"
export * from "./ColorsEditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./ColorsEditorMenu.vue?vue&type=style&index=0&id=45a7d233&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7d233",
  null
  
)

export default component.exports